import React from 'react'
import { Typography } from '@mui/material'
import TextField from 'components/Common/TextField'
import Grid from '@mui/material/Grid'
import StateCode from 'components/Common/StateCodeAutocomplete'
import CountryCode from 'components/Common/CountryCodeAutocomplete'
import PlaceAutoComplete from 'components/Common/PlaceAutoComplete'
import { geocodeByAddress } from 'react-places-autocomplete'
import { searchCountryCodes } from 'store/actions/commonComponentActions'

const LocationSection = ({ onchange, data }) => {
  const handleInput = e => {
    const { name, value } = e.target
    if (name === 'street') {
      loadGeoData(value)
    }
    const address = {
      address: {
        ...data,
        [name]: name === 'street' ? (value ? value.structured_formatting.main_text : null) : value,
      },
    }
    onchange(address)
  }
  const loadGeoData = place => {
    place &&
      geocodeByAddress(place.description)
        .then(results => {
          const { address_components, geometry } = results[0]
          const lat = geometry.location.lat()
          const lon = geometry.location.lng()
          const country = address_components.find(val => val.types.includes('country'))
          const state = address_components.find(val => val.types.includes('administrative_area_level_1'))
          const city = address_components.find(val => val.types.includes('administrative_area_level_2'))
          if (country) {
            searchCountryCodes({ search: country.short_name }, res => {
              onchange({
                address: {
                  ...data,
                  street: place.description,
                  city: city ? city.long_name : null,
                  state: state ? state.short_name : null,
                  countryCode: res[0],
                  lat: lat,
                  lon: lon,
                },
              })
            })
          } else {
            onchange({
              address: {
                ...data,
                street: place.description,
                city: city ? city.long_name : null,
                state: state ? state.short_name : null,
                countryCode: country ? country.short_name : null,
                lat: lat,
                lon: lon,
              },
            })
          }
        })
        .catch(error => console.error('Error', error))
  }
  return (
    <>
      <Typography variant="h6" className="my-5" style={{ color: '#25245F' }}>
        Business Location
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <PlaceAutoComplete
            label="Address"
            name="street"
            bgwhite
            required={true}
            handleValue={option =>
              handleInput({
                target: {
                  name: option.name,
                  value: option.value,
                },
              })
            }
            defaultValue={data.street}
            cityOnly={true}
            zIndex
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            InputLabelProps={{ shrink: false }}
            className="customInput bootstrapLabel"
            label="City"
            size="small"
            fullWidth
            bgwhite
            required={true}
            error={false}
            onChange={handleInput}
            value={data.city}
            name="city"
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <StateCode
            required={true}
            defaultValue={data.state}
            handleOptionChange={option =>
              handleInput({
                target: {
                  name: 'state',
                  value: option,
                },
              })
            }
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            InputLabelProps={{ shrink: false }}
            className="customInput bootstrapLabel"
            label="Zip Code"
            size="small"
            fullWidth
            required
            bgwhite
            name="zipCode"
            onChange={handleInput}
            value={data.zipCode}
            error={false}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <CountryCode
            required={true}
            defaultValue={data.countryCode}
            handleOptionChange={option =>
              handleInput({
                target: {
                  name: 'countryCode',
                  value: option,
                },
              })
            }
          />
        </Grid>
      </Grid>
    </>
  )
}

export default LocationSection
